import { Skeleton } from '@reveni-io/reveni-ui'

import { skeletonCount } from './constants'
import * as Styles from './styles'

const PolicyRuleItemSkeleton = () => (
  <Styles.Container>
    {Array.from({ length: skeletonCount }).map((_, index) => (
      <Styles.ItemContainer key={index} index={index}>
        <Skeleton variant="rounded" width={24} height={24} />
        <Styles.PositionContainer>
          <Skeleton variant="rounded" width={30} height={20} />
        </Styles.PositionContainer>
        <Styles.ContentContainer>
          <Styles.Header>
            <Skeleton variant="rounded" width={40} height={20} />
            <Skeleton variant="rounded" width={200} height={20} />
          </Styles.Header>
          <Styles.ChipsRow>
            <Skeleton variant="rounded" width={120} height={24} />
            <Skeleton variant="rounded" width={140} height={24} />
          </Styles.ChipsRow>
          <Skeleton variant="rounded" width="80%" height={16} />
        </Styles.ContentContainer>
      </Styles.ItemContainer>
    ))}
  </Styles.Container>
)

export default PolicyRuleItemSkeleton
